module.exports = __webpack_public_path__ + "static/img/semi-heavy-tanker-yellow.0863bc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-tanker-yellow.svg
// module id = lOaR
// module chunks = 82